if (!customElements.get('bl-market-card')) {
  customElements.define('bl-market-card', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.addEventListener('change', event => {
        const choice = event.target;
        if (!choice.matches('.blm-choice input')) return;
        const input = this.querySelector('input[name="id"]');
        const button = this.querySelector('.blm-add');
        if (!input || !button) return;
        input.value = choice.value;
        this.querySelector('[data-card-price]').textContent = choice.dataset.price;
        this.querySelector('[data-price-prefix]').textContent = '';
        const available = choice.dataset.available === 'true';
        button.disabled = !available;
        button.removeAttribute('aria-disabled');
        this.querySelector('[data-add-label]').textContent = available ? button.dataset.addText : button.dataset.soldText;
        this.querySelectorAll('[data-product-link]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', choice.value);
          link.href = url.href;
        });
        const error = this.querySelector('.product-form__error-message-wrapper');
        if (error) error.hidden = true;
      });
    }
  });
}
document.querySelectorAll('.blm-nav-group').forEach(item => item.addEventListener('toggle', () => {
  if (item.open) document.querySelectorAll('.blm-nav-group').forEach(other => { if (other !== item) other.open = false; });
}));
document.addEventListener('click', event => {
  if (!event.target.closest('.blm-nav-group')) document.querySelectorAll('.blm-nav-group').forEach(item => { item.open = false; });
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.blm-nav-group').forEach(item => { item.open = false; });
});
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    fetch(window.routes.cart_url + '.js').then(response => response.json()).then(cart => {
      document.querySelectorAll('[data-bl-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    }).catch(() => {});
  });
});
